/**
 * Wrapper around fetch() that automatically appends the current Firebase user's
 * ID token as an Authorization: Bearer header.
 *
 * Drop-in replacement for fetch() in client components that call authenticated
 * API routes (e.g. /api/ai/*, /api/notify, etc.).
 *
 * Usage:
 *   import { fetchWithAuth } from '@/lib/fetch-with-auth';
 *   const res = await fetchWithAuth('/api/ai/translate-lyrics', { method: 'POST', ... });
 */

import { auth } from '@/lib/firebase';

export async function fetchWithAuth(
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> {
  let idToken: string | undefined;

  try {
    idToken = await auth.currentUser?.getIdToken() ?? undefined;
  } catch {
    // Not fatal — the server will return 401 if the token is missing
  }

  const headers = new Headers(init.headers);
  if (idToken) {
    headers.set('Authorization', `Bearer ${idToken}`);
  }

  return fetch(input, { ...init, headers });
}
